/* eslint-disable consistent-return */
/* eslint-disable no-underscore-dangle */
/* eslint-disable class-methods-use-this */
import { Quill } from 'react-quill';

const Module = Quill.import('core/module');
const BlockEmbed = Quill.import('blots/block/embed');
const ATTRIBUTES = ['alt', 'height', 'width', 'style'];
const WHITE_STYLE = ['margin', 'padding', 'display', 'float'];
/* eslint-disable no-console */

class ImageBlot extends BlockEmbed {
  static blotName = 'image';
  static tagName = ['figure', 'image'];

  static formats(domNode) {
    const formatResult = ATTRIBUTES.reduce((formats, attribute) => {
      if (domNode.hasAttribute(attribute)) {
        formats[attribute] = domNode.getAttribute(attribute);
      }
      return formats;
    }, {});
    return formatResult;
  }

  format(name, value) {
    if (ATTRIBUTES.indexOf(name) > -1) {
      if (value) {
        if (name === 'style') {
          value = this.sanitizeStyle(value);
        }

        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      super.format(name, value);
    }
  }

  sanitizeStyle(style) {
    const styleArr = style.split(';');
    let allowStyle = '';
    styleArr.forEach((v) => {
      if (WHITE_STYLE.indexOf(v.trim().split(':')[0]) !== -1) {
        allowStyle += `${v};`;
      }
    });
    return allowStyle;
  }

  static create(value) {
    const node = super.create();
    const img = window.document.createElement('img');
    img.setAttribute('alt', value.alt || value.caption || 'body-image');

    if (value.src || typeof value === 'string') {
      img.setAttribute('src', value.src || value);
    }
    if (value.width || typeof value === 'string') {
      img.setAttribute('width', value.width || value);
    }
    node.appendChild(img);
    if (value.caption) {
      const caption = window.document.createElement('figcaption');
      caption.innerHTML = value.caption;
      caption.className = 'quill-caption';
      node.className = `ql-card-editable ql-card-figure ${value.align}`;
      node.appendChild(caption);
    } else {
      node.className = `ql-card-editable ql-card-figure ${value.align} no-figcap`;
    }
    return node;
  }

  constructor(node) {
    super(node);
    node.__onSelect = () => {
      if (!node.querySelector('input')) {
        let caption = node.querySelector('figcaption');
        const captionInput = window.document.createElement('input');
        captionInput.placeholder = '이미지 캡션을 넣어주세요.';
        if (caption) {
          captionInput.value = caption.innerText;
          caption.innerHTML = '';
          caption.appendChild(captionInput);
          caption.className = 'quill-caption';
        } else {
          caption = window.document.createElement('figcaption');
          caption.appendChild(captionInput);
          caption.className = 'quill-caption';
          node.appendChild(caption);
        }
        captionInput.addEventListener('blur', () => {
          const { value } = captionInput;
          if (!value || value === '') {
            caption.remove();
          } else {
            captionInput.remove();
            caption.innerText = value;
          }
        });
        captionInput.focus();
      }
    };
  }

  static value(node) {
    const img = node.querySelector('img');
    const figcaption = node.querySelector('figcaption');
    if (!img) return false;
    const style = node.getAttribute('style');
    let alignClass = '';
    if (style) {
      if (style.includes('float: left')) alignClass = 'ql-card-figure-left';
      else if (style.includes('float: right')) alignClass = 'ql-card-figure-right';
    }

    return {
      alt: img.getAttribute('alt'),
      src: img.getAttribute('src'),
      caption: figcaption ? figcaption.innerText : null,
      width: img.getAttribute('width'),
      align: alignClass
    };
  }
}

class CardEditableModule extends Module {
  constructor(quill, options) {
    super(quill, options);
    const listener = (e) => {
      if (!document.body.contains(quill.root)) {
        return document.body.removeEventListener('click', listener);
      }
      const elm = e.target.closest('.ql-card-editable');
      const deselectCard = () => {
        if (elm.__onDeselect) {
          elm.__onDeselect(quill);
        } else {
          quill.setSelection(quill.getIndex(elm.__blot.blot) + 1, 0, Quill.sources.USER);
        }
      };
      if (elm && elm.__blot && elm.__onSelect) {
        quill.disable();
        elm.__onSelect(quill);
        const handleKeyPress = (evt) => {
          if (evt.keyCode === 27 || evt.keyCode === 13) {
            window.removeEventListener('keypress', handleKeyPress);
            quill.enable(true);
            deselectCard();
          }
        };
        const handleClick = (evt) => {
          if (evt.which === 1 && !elm.contains(evt.target)) {
            window.removeEventListener('click', handleClick);
            quill.enable(true);
            deselectCard();
          }
        };
        window.addEventListener('keypress', handleKeyPress);
        window.addEventListener('click', handleClick);
      }
    };
    quill.emitter.listenDOM('click', document.body, listener);
  }
}

export { ImageBlot, CardEditableModule };
